@if (showAvatar && userId) {
    <div class="avatar"  [ngClass]= "cssVariant">
        <div class="avatar-content">
            <app-secured-image-display [data]="userId?.toString()"
                                       (imageLoaded)="onSuccess()"
                                       (loadingError)="onError()"
                                       (loading)="onLoading()"
                                       [alt] ="alt ?? ' avatar'"
                                       [style.height]= 'height'
                                       [style.width]="width"
                                       class="user-avatar"
            >
            </app-secured-image-display>
        </div>
    </div>
} @else {
    <div class="avatar bg-light-primary" [ngClass]= "cssVariant" [style.backgroundColor]="backgroundColor">
        <span class="avatar-content" [ngClass]= "cssAvatarContent" >{{ shortcutName }}</span>
    </div>
}
